<template>
  <div class="rp-reviewer-filter">
    <v-select
      v-if="!dataLoad"
      v-model="selected"
      class="rp-reviewer-select"
      :options="optionsEngineers"
      :placeholder="placeholder"
      label="label"
      multiple
      :searchable="true"
      :clearable="true"
      @input="handleChange"
    />
  </div>
</template>

<script>
import VSelect from 'vue-select'

export default {
  name: 'SelectReviewerFilter',
  components: {
    'v-select': VSelect,
  },
  props: {
    queryKey: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selected: [],
    }
  },
  computed: {
    optionsEngineers() {
      return this.$store.getters['generalData/engineersList/engineersList']
    },
    placeholder() {
      return this.label ? `Select ${this.label}` : 'Select'
    },
  },
  watch: {
    '$route.query': {
      handler(query) {
        const raw = query[this.queryKey]
        if (raw == null || raw === '') {
          this.selected = []
          return
        }
        const ids = Array.isArray(raw) ? raw : String(raw).split(',').map(s => s.trim()).filter(Boolean)
        const list = this.optionsEngineers || []
        this.selected = ids.map(id => list.find(o => String(o.value) === String(id))).filter(Boolean)
      },
      immediate: true,
    },
  },
  mounted() {
    if (!this.$store.getters['generalData/engineersList/engineersLoaded']) {
      this.$store.dispatch('generalData/engineersList/fetchEngineersList')
    }
  },
  methods: {
    handleChange() {
      const value = this.selected && this.selected.length
        ? this.selected.map(item => item.value)
        : undefined
      const query = { ...this.$route.query }
      if (value) {
        query[this.queryKey] = value
      } else {
        delete query[this.queryKey]
      }
      this.$router.push({ query })
    },
  },
}
</script>

<style scoped lang="scss">
.rp-reviewer-filter {
  width: 100%;
}

.rp-reviewer-select ::v-deep .vs__dropdown-toggle {
  min-height: 34px;
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
}

.rp-reviewer-select ::v-deep .vs__selected {
  font-size: 0.78rem;
}
</style>
